import React, { useEffect } from "react";
import Hitechabout from "./Hitechabout";
import Hitechservices from "./Hitechservices";
import Bankingexplore from "./Bankingexplore";
import Hitechsolutions from "./Hitechsolutions";
import Hitechbanner from "./Hitechbanner";

const Hitech= () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      style={{
        backgroundImage:
          "url('/image/3662a43d-artificial-intelligence.jpeg.optimal.jpeg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
        minHeight: "100vh",
        width: "100%",
      }}
    >
      <div style={{ backgroundColor: "rgba(255, 255, 255, 0.1)" }}>
        <Hitechbanner/>
        <Hitechabout/>
        <Hitechservices/>

        {/* <Bankingexplore/> */}
        <Hitechsolutions/>
      </div>
    </div>
  );
};

export default Hitech;
